import React from 'react';
import { Tabs, Box } from '@mui/material';
import cn from 'classnames/bind';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { useAppSelector } from '../../hooks/useAppSelector';
import { organizerSlice } from '../../store/slice/slice';
import { childBoxStyles, mainBoxStyles, useStyles } from './TabsPanel.styles';

export const TabsPanel = (): JSX.Element => {
  const tabs = useAppSelector((state) => state.organizerReducer.tabs);
  const dispatch = useAppDispatch();
  const classes = useStyles();
  const cx = cn.bind(classes);

  const handleChange = (newValue: number) => {
    dispatch(organizerSlice.actions.setTabs(newValue));
  };

  const currentTab = cx(classes.tabs, {
    activeTabs: tabs === 0,
  });

  const completedTab = cx(classes.tabs, {
    activeTabs: tabs === 1,
  });

  const allTab = cx(classes.tabs, {
    activeTabs: tabs === 2,
  });

  return (
    <div className={classes.mainTabsBlock}>
      <Box sx={mainBoxStyles}>
        <Box sx={childBoxStyles}>
          <Tabs>
            <div
              className={currentTab}
              onClick={(): void => handleChange(0)}
            >
              Current
            </div>
            <div
              className={completedTab}
              onClick={(): void => handleChange(1)}
            >
              Completed
            </div>
            <div
              className={allTab}
              onClick={(): void => handleChange(2)}
            >
              All
            </div>
          </Tabs>
        </Box>
      </Box>
    </div>
  );
};
